import loadImgs from '../lib/loadImgs';
import { playEffect, fadeBgTo } from '../lib/audio';

let w, h, x, y,
    canvas, c,
    nextAction,
    speed = 2,
    distance = 0,
    lane = 1, // 0, 1, 2
    lanePos = [24, 64, 104],
    playerPos = lanePos[1],
    loaded = false,
    running = false,
    gonnaCrash = false,
    crashed = false,
    obstacles = [],
    obTimeout,
    assets,
    prevT;

const assetsUrls = {
  bg: '/games/ski/bakke.gif',
  down: '/games/ski/ned-statisk.gif',
  turn_l: '/games/ski/sving-v_statisk.gif',
  turn_r: '/games/ski/sving-h_statisk.gif',
  crashed: '/games/ski/ski-crash.gif',
  tre1: '/games/ski/tre1.gif',
  tre2: '/games/ski/tre2.gif',
  stein1: '/games/ski/stein1.gif',
  stein2: '/games/ski/stein2.gif',
  splash: '/games/ski/ski-splash.gif',
  gameover: '/games/gameover.gif'
};

const obs = [
  {
    name: 'tre1',
    offsetX: 13,
    offsetY: 28
  },
  {
    name: 'tre2',
    offsetX: 13,
    offsetY: 29
  },
  {
    name: 'stein1',
    offsetX: 14,
    offsetY: 0
  },
  {
    name: 'stein2',
    offsetX: 8,
    offsetY: 0
  }
];


function loop(t) {
  let timeDelta = 16.6;
  if (t - prevT < 50) {
    timeDelta = t - prevT;
  }
  prevT = t;

  if (running) {
    requestAnimationFrame(loop);
  } else {
    return;
  }

  if (gonnaCrash) {
    crashed = true;
    running = false;
    playEffect('/audio/game_explosion_2.mp3');
    setTimeout(gameOver, 1000);
  }

  // Handle input
  if (!crashed) {
    switch(nextAction) {
    case 'left':
      if (lane > 0) {
        lane = lane - 1;
        playEffect('/audio/game_move_1.mp3');
      }
      break;
    case 'right':
      if (lane < 2) {
        lane = lane + 1;
        playEffect('/audio/game_move_1.mp3');
      }
      break;
    }
  }
  nextAction = null;


  c.clearRect(0, 0, w, h);
  // Render background
  const bgpos = 256 - (distance % 256);
  c.drawImage(assets.bg, 0, bgpos, w, 256);
  c.drawImage(assets.bg, 0, bgpos - 256, w, 256);

  // Draw player
  var playerImg = assets['down'];
  var playerOffset = 5;
  var posMove = 8;
  if (timeDelta < 20) {
    posMove = 4;
  }
  if (lane == 0 && playerPos > lanePos[0]) {
    playerPos = playerPos - posMove;
    playerImg = assets['turn_l'];
    playerOffset = 17;
  } else if (lane == 2 && playerPos < lanePos[2]) {
    playerPos = playerPos + posMove;
    playerImg = assets['turn_r'];
    playerOffset = 17;
  } else if (lane == 1 && playerPos > lanePos[1]) {
    playerPos = playerPos - posMove;
    playerImg = assets['turn_l'];
    playerOffset = 17;
  } else if (lane == 1 && playerPos < lanePos[1]) {
    playerPos = playerPos + posMove;
    playerImg = assets['turn_r'];
    playerOffset = 17;
  }

  if (gonnaCrash) {
    playerImg = assets['crashed'];
    playerOffset = 14;
  }

  c.drawImage(playerImg, playerPos - playerOffset, 11);

  let delta = (speed * timeDelta / 20);

  // Draw obstacles
  for (let i = 0; i < obstacles.length; i++) {
    let o = obstacles[i];

    c.drawImage(assets[o.o.name], lanePos[o.lane] - o.o.offsetX, o.y - o.o.offsetY);

    // Check collision
    if (Math.abs(playerPos - lanePos[lane]) < 20 && o.lane == lane && o.y < 38 && o.y > 13) {
      gonnaCrash = true;
    }

    if (!crashed) {
      obstacles[i].y -= delta;
    }
  }


  // Draw UI
  c.fillStyle = 'black';
  c.textAlign = 'start';
  c.fillText(Math.round(distance / 18) + 'm', 3, 10);

  if (!crashed) {
    distance += delta;
    speed = Math.min(8, speed + 0.0015);
  }

}

async function gameOver() {
  fadeBgTo(0);
  playEffect('/audio/game_over.mp3');
  c.drawImage(assets['gameover'], 0, 0);
  c.fillStyle = 'white';
  c.textAlign = 'center';

  let score = Math.round(distance / 18);

  let points;
  if (score <= 100) {
    points = Math.max(1, Math.floor(score / 100 * 10));
  } else if (score <= 250) {
    points = 10 + Math.floor((score - 100) / 250 * 10);
  } else {
    points = Math.min(30, 20 + Math.floor((score - 250) / 250 * 10));
  }

  c.fillText('Your distance:', 62, 50);
  c.fillText(score + 'm', 62 + ((score.toString().length + 1) % 2) / 2, 68);  
}


function obstacle() {
  obstacles = obstacles.filter(o => o.y > - 40);

  let ob1num = Math.floor(Math.random() * 4);

  let ob1 = {
    lane: Math.floor(Math.random() * 3),
    y: 210,
    o: obs[ob1num]
  };

  let ob2 = {
    lane: Math.floor(Math.random() * 3),
    y: 200 + Math.floor(Math.random() * 20),
    o: obs.slice(0, ob1num).concat(obs.slice(ob1num + 1))[Math.floor(Math.random() * 3)]
  };

  obstacles.push(ob1);

  if (ob2.lane != ob1.lane) {
    obstacles.push(ob2);
  }

  if (running) {
    obTimeout = setTimeout(obstacle, (Math.random() * 4000 + 4000) / speed);
  }
}


function restart() {
  if (running || !loaded) {
    return;
  }
  fadeBgTo(0.3);
  nextAction = null;
  prevT = null;
  speed = 2;
  distance = 0;
  clearTimeout(obTimeout);
  obstacles = [];
  lane = 1;
  playerPos = lanePos[1];
  crashed = false;
  gonnaCrash = false;
  running = true;
  requestAnimationFrame(loop);
  obstacle();
}

export default {
  init(can, wi, he) {
    canvas = can;
    w = wi;
    h = he;

    c = canvas.getContext('2d');
    c.font = '16px basis33, courier, monospace';

    loadImgs.assoc(assetsUrls).then(a => {
      assets = a;
      c.drawImage(assets.splash, 0, 0, w, h);
      loaded = true;
    });
  },

  event(what) {
    switch(what) {
    case 'left':
    case 'right':
      if (running) {
        nextAction = what;
      }
      break;
    case 'btn':
      restart();
    }
  },

  stop() {
    running = false;
  }


};

